// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B60I","questions":"styles_questions__7YwTy","footer":"styles_footer__303Xf"};